import React, { useState } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import CreateOrCloneEventLeague from './steps/create_or_clone_event_league'
import CreateEventOrLeague from './steps/create_event_or_league'
import SelectEventToClone from './steps/select_event_to_clone'
import DetailsEventOrLeague from './steps/details_event_or_league'
import ScheduleRounds from '../../../../shared/components/schedule_rounds/schedule_rounds'
import ReviewAndCreate from './steps/review_and_create'
import PartsToCloneFromEventLeague from './steps/parts_to_clone_from_event_league'

const CreateCloneEventLeagueFormContent = ({
  step,
  setStep,
  handleNext,
  customerId,
  categoriesOptions,
  currentSeasonId,
  leagueToClone,
  getLeagueFieldDataSimGolf,
  getLeaguePotentialCloneCandidate,
  details,
  setDetails,
  copyOptionsFields,
  setCopyOptionsFields,
  givenDays,
  setGivenDays,
  startDate,
  setStartDate,
  numberOfWeeks,
  setNumberOfWeeks,
  selectedButton,
  setSelectedButton,
  selectedWeekDays,
  setSelectedWeekDays,
}) => {
  const [dayRoundNumber, setDayRoundNumber] = useState({})

  switch(step) {
    case 1:
      return (
        <CreateOrCloneEventLeague
          handleNext={ handleNext }
          setDetails={ setDetails }
          details={ details }
        />
      )
    case 2:
      return (
        details.actionType === 'createEvent' ?
          <CreateEventOrLeague
            handleNext={ handleNext }
            details={ details }
            setDetails={ setDetails }
          /> :
          <SelectEventToClone
            details={ details }
            setDetails={ setDetails }
            getLeagueFieldDataSimGolf={ getLeagueFieldDataSimGolf }
          />
      )
    case 3:
      return (
        <DetailsEventOrLeague
          currentSeasonId={ currentSeasonId }
          categoriesOptions={ categoriesOptions }
          getLeagueFieldDataSimGolf={ getLeagueFieldDataSimGolf }
          details={ details }
          setDetails={ setDetails }
        />
      )
    case 4:
      return (
        (details.actionType === 'createEvent') ?
          <ScheduleRounds
            details={ details }
            setDetails={ setDetails }
            dayRoundNumber={ dayRoundNumber }
            setDayRoundNumber={ setDayRoundNumber }
            givenDays={ givenDays }
            setGivenDays={ setGivenDays }
            startDate={ startDate }
            setStartDate={ setStartDate }
            numberOfWeeks={ numberOfWeeks }
            setNumberOfWeeks={ setNumberOfWeeks }
            selectedButton={ selectedButton }
            setSelectedButton={ setSelectedButton }
            selectedWeekDays={ selectedWeekDays }
            setSelectedWeekDays={ setSelectedWeekDays }
          /> :
          <PartsToCloneFromEventLeague
            details={ details }
            setDetails={ setDetails }
            getLeaguePotentialCloneCandidate={ getLeaguePotentialCloneCandidate }
            copyOptionsFields={ copyOptionsFields }
            setCopyOptionsFields={ setCopyOptionsFields }
          />
      )
    case 5:
      return (
        (details.actionType === 'createEvent') ?
          <ReviewAndCreate
            customerId={ customerId }
            categoriesOptions={ categoriesOptions }
            details={ details }
            setDetails={ setDetails }
            dayRoundNumber={ dayRoundNumber }
            setStep={ setStep }
          /> :
          <ScheduleRounds
            details={ details }
            setDetails={ setDetails }
            dayRoundNumber={ dayRoundNumber }
            setDayRoundNumber={ setDayRoundNumber }
            givenDays={ givenDays }
            setGivenDays={ setGivenDays }
            startDate={ startDate }
            setStartDate={ setStartDate }
            numberOfWeeks={ numberOfWeeks }
            setNumberOfWeeks={ setNumberOfWeeks }
            selectedButton={ selectedButton }
            setSelectedButton={ setSelectedButton }
            selectedWeekDays={ selectedWeekDays }
            setSelectedWeekDays={ setSelectedWeekDays }
          />
      )
    case 6:
      return (
        (details.actionType !== 'createEvent') &&
          <ReviewAndCreate
            customerId={ customerId }
            categoriesOptions={ categoriesOptions }
            details={ details }
            setDetails={ setDetails }
            dayRoundNumber={ dayRoundNumber }
            setStep={ setStep }
          />
      )
    default:
      return null
  }
}

CreateCloneEventLeagueFormContent.propTypes = {
  step: PropTypes.number.isRequired,
  setStep: PropTypes.func.isRequired,
  handleNext: PropTypes.func.isRequired,
  customerId: PropTypes.string,
  currentSeasonId: PropTypes.string,
  categoriesOptions: PropTypes.array.isRequired,
  details: PropTypes.object.isRequired,
  setDetails: PropTypes.func.isRequired,
  leagueToClone: PropTypes.number.isRequired,
  getLeagueFieldDataSimGolf: PropTypes.func.isRequired,
  copyOptionsFields: PropTypes.object.isRequired,
  setCopyOptionsFields: PropTypes.func.isRequired,
  givenDays: PropTypes.array.isRequired,
  setGivenDays: PropTypes.func.isRequired,
  startDate: PropTypes.string.isRequired,
  setStartDate: PropTypes.func.isRequired,
  numberOfWeeks: PropTypes.string.isRequired,
  setNumberOfWeeks: PropTypes.func.isRequired,
  selectedButton: PropTypes.string.isRequired,
  setSelectedButton: PropTypes.func.isRequired,
  selectedWeekDays: PropTypes.object.isRequired,
  setSelectedWeekDays: PropTypes.func.isRequired,
}

export default CreateCloneEventLeagueFormContent
